import { render, staticRenderFns } from "./TdRelationsBlockLots.vue?vue&type=template&id=04fcec37"
import script from "./TdRelationsBlockLots.vue?vue&type=script&lang=js"
export * from "./TdRelationsBlockLots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports